import { getBaseUrl, request } from 'src/helper/api';

export const getJobDetails = (workOrderId?: string, signal?:{}) => request(
  {
    method: 'GET',
    url: `${getBaseUrl()}api/work-order/${workOrderId}`,
    contentType: 'json',
    signal,
  },
  'jobDetails/getJobDetails',
);
export const workOrderActionAPI = (workOrderId?: string, actionType?:string) => request(
  {
    method: 'POST',
    url: `${getBaseUrl()}api/work-orders/${workOrderId}${actionType}`,
    contentType: 'json',
  },
  'jobDetails/workOrderActionAPI',
);

export const getWebHooks = (workOrderId?: string, signal?:{}) => request(
  {
    method: 'GET',
    url: `${getBaseUrl()}api/work-order/${workOrderId}/webhook-ping`,
    contentType: 'json',
    signal,
  },
  'jobDetails/getWebHooks',
);
